import React from "react";
import { themeDefault } from "src/theme-revamp";
import { styled } from "@linaria/react";
import { Text } from "../Text";

interface ProgressBarProps {
  progress: number;
}

const ProgressBar = ({ progress }: ProgressBarProps) => {
  const Container = styled.div`
    height: 5px;
    width: 100%;
    background-color: #d8d8d8;
    border-radius: 2px;
    margin: 4px;
  `;

  const Filler = styled.div<{ progress: number }>`
    height: 100%;
    background-color: #883E89;
    border-radius: inherit;
    text-align: right;
    width: ${(props) => `${props.progress}%`};
  `;

  return (
    <div>
      <Text variant="base" fontSize="10px">{`Uploading... ${progress}%`}</Text>
      <Container>
        <Filler progress={progress} />
      </Container>
    </div>
  );
};

export default ProgressBar;
